<template>
  <slider-layout is-show-overlay gray-bg>
      <div class="col-lg-10 ml-auto mr-auto mt-3">
              <card>
                <!-- <button
                  type="button"
                  class="pull-right close"
                  @click="$router.push('/home')"
                >
                  X
                </button> -->

              <h4 class="header text-center">광고주/대행사 소속 담당자 비밀번호 초기화</h4>
              <hr class="mb-4"/>
              <div class="text-center" style="margin:50px; font-size:1.2em">
                <div v-if="success === true">
                  <p>회원님의 초기화된 비밀번호는</p>
                  <p><span class="text-danger font-size:1.4em">{{pwd}}</span> 입니다.</p>
                  <p>초기화된 비밀번호로 로그인하신 후 ‘내정보 수정’에서 다시 변경해주세요</p>
                </div>
                <div v-if="success === false">
                  <p>기간이 만료된 페이지 입니다.</p>
                  <p>메인으로 가셔서 비밀번호 초기화를 다시 시도해 주세요</p>
                </div>

              </div>
              <div class="text-center pb-5">
                <el-button @click="$router.push('/home')" icon="el-icon-house">메인으로 이동</el-button>
              </div>
            </card>
            </div>
  </slider-layout>
</template> 

<script>
  import AppFooter from 'src/components/Pages/Views/Layout/AppFooter'
  import CommonProxy from '@/proxies/CommonProxy';
  import * as Util from '@/util/util'
  import _ from 'lodash'
  import SliderLayout from './Layout/SliderLayout.vue';

  export default {
    components: {
      AppFooter,
      SliderLayout
    },
    created() {

      new CommonProxy()
          .pwdConfirm( this.$route.params.uuid )
          .then(response => {
            this.success = response.success
            this.pwd = response.pwd
          })

    },
    data() {
      return {
        success: undefined,
        pwd: undefined,
      }
    }
  }
</script>
<style>
  .join-page {
    background-image: url(/static/commons/images/main_bg.jpg);
    min-height: 100vh;
    background-size: cover;
  }  
  .join-page .logo {width: 221px;height: 64px;background: url("/static/commons/images/main_logo.png") no-repeat; margin:0 auto;position: absolute;background-size: contain;z-index: 1000;margin: 30px;}

  .join-page .card label {
    color: #606266;
    font-size: 14px;
  }

</style>
